import React from "react";
import { Box } from "@mui/material";
import CivixButton from "../../components/ui/CivixButton";

const ANCHORS = [
  { href: "#citizen-features", label: "Built for citizens" },
  { href: "#organizer-features", label: "Built for organizers" },
  { href: "#organizer-plan", label: "Organizer Plan" },
  { href: "#verification", label: "Verification" },
];

export default function JoinAnchorRail() {
  return (
    <Box
      component="nav"
      aria-label="Features page sections"
      sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: { xs: 1.75, md: 2.25 },
        justifyContent: "center",
        py: 1.5,
        px: { xs: 1, md: 2 },
        bgcolor: "transparent",
        position: "sticky",
        top: { xs: 56, md: 64 },
        zIndex: 10,
      }}
    >
      {ANCHORS.map((link) => (
        <CivixButton
          key={link.href}
          component="a"
          href={link.href}
          label={link.label}
          size="sm"
          variant="primary"
          sx={{
            fontSize: 13,
            fontWeight: 600,
            px: 2,
            minHeight: 44,
            textTransform: "uppercase",
            letterSpacing: "0.04em",
          }}
        />
      ))}
    </Box>
  );
}
